<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item ml-1 mr-0 rounded-left"
    :class="[
      {
        'custom-active-link': isActive,
        disabled: item.disabled,
      },
      item.navItemClass,
    ]"
  >
    <b-link
      v-bind="linkProps"
      :class="['d-flex align-items-center mr-0', item.navLinkClass]"
    >
      <feather-icon
        :class="isActive ? 'text-dark' : ''"
        :icon="item.icon || 'CircleIcon'"
      />
      <span
        :class="isActive ? 'text-dark' : ''"
        class="menu-title text-truncate"
      >{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(
      props.item,
    )
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },
}
</script>
<style lang="scss" scoped>
.custom-active-link {
  background-color: #f3f3f3;
  color: #000 !important;
}

.ticket-raise-cta-item {
  margin-top: 0.85rem;
  padding: 0 0.2rem;
}

.ticket-raise-cta-link {
  min-height: 44px;
  border-radius: 0.65rem;
  padding-left: 0.85rem;
  background: linear-gradient(120deg, #1fbf75 0%, #10a062 100%);
  border: 1px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.ticket-raise-cta-link .menu-title {
  color: #fff;
  font-weight: 600;
}

.ticket-raise-cta-link .feather {
  color: #fff;
}

.ticket-raise-cta-item.custom-active-link {
  background-color: transparent;
}

.ticket-raise-cta-item.custom-active-link .ticket-raise-cta-link {
  background: #fff;
  border-color: #fff;
}

.ticket-raise-cta-item.custom-active-link .ticket-raise-cta-link .menu-title,
.ticket-raise-cta-item.custom-active-link .ticket-raise-cta-link .feather {
  color: #0b0f8f;
}
</style>
